module.exports = __webpack_public_path__ + "static/finance-app@2x-174b5f66da977076af3d72acb582dfde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/finance-app@2x.jpg
// module id = 878
// module chunks = 71833740541355 256871573202158